import { Typography } from 'antd';
import styled, { css } from 'styled-components';

export type Gap = 'small' | 'medium' | 'large';
export type Layout = 'horizontal' | 'vertical';

export const StyledSection = styled.section<{ $layout: Layout; $gapPx: number; $bordered: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;

    padding: ${({ $layout }) => ($layout === 'vertical' ? '16px 24px' : '24px')};
    gap: ${({ $gapPx }) => $gapPx}px;
    ${({ $bordered }) =>
        $bordered &&
        css`
            background-color: var(--gray-1);
            border-radius: 6px;
            border: 1px solid var(--gray-4);
        `}
`;

export const StyledHeaderRow = styled.div<{
    $layout: Layout;
    $gapPx: number;
}>`
    display: flex;
    gap: ${({ $gapPx }) => $gapPx}px;

    ${({ $layout }) =>
        $layout === 'vertical'
            ? css`
                  align-items: center;
              `
            : css`
                  align-items: flex-start;
              `}
`;

export const StyledRightColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const StyledTitle = styled(Typography)`
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
`;
